export const Errors = {
  AddressRequired: "Post Code is required",
  EmailPhoneRequired: "One of email or phone number is required.",
  EmailIncorrectFormat: "Incorrect email address format.",
  EmailRequired: "Email address is required.",
  EmailCountTooHigh: "Please try again later.",
  PhoneNumberRequired:"Phone number is required",
  PhoneNumberIncorrectFormat: "invalid NZ phone number"
};
